<template>
	<div class="w1200 choiceFood">
		<div class="flex choiceFood_1">
			<div class="flex benben-flex-layout flex-wrap align-center pointer " @click="caozuo(1)">
				<img class="login_14_1" src="https://api.ezlunch.club/pc/image/13.png" alt="" srcset="">
				<div class="login_14_2">{{$t('返回')}}</div>
			</div>
		</div>
		<div class="" v-if="xuan_detl">
			<div class="flex justify-between choiceFood_2">
				<div class="choiceFood_2_1" v-if="can_type.aid == 1">{{$t('两菜点餐')}}</div>
				<div class="choiceFood_2_1" v-if="can_type.aid == 2">{{$t('三菜点餐')}}</div>
				<div class="choiceFood_2_2 pointer" @click="tijiao">{{$t('确认')}}</div>
			</div>
			<div v-loading="loading"  :element-loading-text="$t('拼命加载中')">
				<div v-if="oerde_list.length > 0">
				    <template v-for="(item,index) in oerde_list">
				    	<div class="flex flex benben-flex-layout flex-wrap align-center choiceFood_3">
				    		<div class="choiceFood_3_1 pointer" @click="caozuo(2,index)">
				    			<img class="choiceFood_3_2" v-if="item.xu_bur" src="https://api.ezlunch.club/pc/image/21.png" alt="" srcset="">
				    		</div>
				    		<div class="choiceFood_3_3">{{$t('选择')}}{{item.date_week}}（{{item.date}}）{{$t('套餐')}}</div>
				    	</div>
				    	<div class="flex flex-direction align-stretch benben-flex-layout choiceFood_4">
				    		<template v-for="(itm,idex) in item.package_list">
				    			<div class="flex pointer choiceFood_5" @click="caozuo(5,itm)">
				    				<img class="choiceFood_6" src="https://api.ezlunch.club/pc/image/16.png" alt="" srcset="">
				    				<div class="choiceFood_7 flex flex-direction align-stretch benben-flex-layout flex-sub">
				    					<div class="choiceFood_7_1">{{itm.name}}</div>
				    					<div class="choiceFood_7_2">{{itm.describe}}</div>
				    					<div class="flex benben-flex-layout flex-wrap align-center choiceFood_7_3">
				    						<img class="choiceFood_7_4 pointer" @click.stop="caozuo(3,index,idex)" src="https://api.ezlunch.club/pc/image/22.png" alt="" srcset="">
				    						<div class="choiceFood_7_5">{{itm.num}}</div>
				    						<img class="choiceFood_7_4 pointer" @click.stop="caozuo(4,index,idex)" src="https://api.ezlunch.club/pc/image/23.png" alt="" srcset="">
				    					</div>
				    				</div>
				    			</div>
				    		</template>
				    	</div>
				    </template>
			    </div>
			    <div v-else style="text-align: center;padding: 40px 0;">
			    	<img style="width: 217px;height: 177px;" src="https://api.ezlunch.club/pc/image/29.png" alt="" srcset="">
			    </div>
				
			</div>
			
		</div>
		<div v-else>
			<div class="choiceFood_8">
				<div class="choiceFood_8_1">{{detail.name}}</div>
				<div class="choiceFood_8_2">{{detail.describe}}</div>
				<div class="choiceFood_8_3"></div>
				<div class="index8">
					<div class="content-h" v-html="detail.body"></div>
				</div>
				<div class="orderFood_6" v-if="detail.images && detail.images.length > 0">
					<el-carousel trigger="click" height="700px">
						<template v-for="(item,index) in detail.images">
							<el-carousel-item>
							    <img class="orderFood_7" :src="item" alt="" srcset="">
							</el-carousel-item>
						</template>
					    
					</el-carousel>
				</div>
			</div>
		</div>
		<el-dialog class="footer_6" title="" :visible.sync="visible1" width="560px" >
			<div class="choiceFood_9">
				<div class="flex align-center justify-between benben-flex-layout choiceFood_9_1">
					<div class="choiceFood_9_2">{{$t('选择配送地址')}}</div>
					<img class="choiceFood_9_3 pointer" @click.stop="visible1 = false" src="https://api.ezlunch.club/pc/image/24.png" alt="" srcset="">
				</div>
				<div v-if="addres_list.length > 0">
				<div class="beizhu">
					<div class="choiceFood_10_3">{{$t('备注')}}</div>
					<el-input
					class="beizhu_1"
					  type="textarea"
					  :rows="2"
					  :placeholder="$t('请输入备注')"
					  v-model="textarea">
					</el-input>
				</div>
					<div class="choiceFood_10">
						<template v-for="(item,index) in addres_list">
							<div class="flex benben-flex-layout flex-wrap align-center pointer " @click="caozuo(6,item)" :class="addres_id == item.aid ? 'choiceFood_10_1s' : 'choiceFood_10_1'">
								<img class="choiceFood_10_2" v-if="addres_id == item.aid" src="https://api.ezlunch.club/pc/image/26.png" alt="" srcset="">
								<img class="choiceFood_10_2" v-else src="https://api.ezlunch.club/pc/image/25.png" alt="" srcset="">
							    <div class="flex-sub">
							    	<div class="choiceFood_10_3">{{item.address}}{{item.detail}}</div>
							    	<div class="choiceFood_10_4">{{item.real_name}}（{{item.sex == 1 ? $t('先生') : $t('女士')}}）18212312336</div>
							    </div>
							</div>
						</template>
					</div>
					
					<div class="flex choiceFood_11">
						<div class="choiceFood_11_1 pointer" @click="caozuo(7)">+{{$t('新增地址')}}</div>
						<div class="choiceFood_11_2 pointer" @click="queding">{{$t('确定')}}</div>
					</div>
				</div>
				<div v-else class="flex flex-direction flex-wrap align-center benben-flex-layout">
					<img class="choiceFood_12" src="https://api.ezlunch.club/pc/image/27.png" alt="" srcset="">
					<div class="choiceFood_12_1">{{$t('暂无可用地址')}}</div>
					<div class="choiceFood_12_2 pointer" @click="caozuo(7)">+{{$t('新增地址')}}</div>
				</div>
			</div>
		</el-dialog>
		<el-dialog class="footer_6" title="" :visible.sync="visible2" width="460px" >
			<div class="choiceFood_9">
				<div class="flex align-center justify-between benben-flex-layout choiceFood_9_1">
					<div class="choiceFood_9_2">{{$t('温馨提示')}}</div>
				</div>
				<div class="flex flex-direction flex-wrap align-center benben-flex-layout">
					<div class="choiceFood_14">{{$t('选中的日期都需要选择菜品哦')}}~</div>
					<div class="choiceFood_13 pointer" @click="visible2 = false">{{$t('知道了')}}</div>
				</div>
			</div>
		</el-dialog>
		<el-dialog class="footer_6" title="" :visible.sync="visible3" width="460px" >
			<div class="choiceFood_9">
				<div class="flex align-center justify-between benben-flex-layout choiceFood_9_1">
					<div class="choiceFood_9_2">{{$t('温馨提示')}}</div>
				</div>
				<div class="fflex flex-direction align-stretch benben-flex-layout choiceFood_17" >
					<div class="choiceFood_15">{{$t('饭票不足，请前往充值')}}</div>
					<div class="flex choiceFood_16">
						<div class="choiceFood_16_1 pointer" @click="visible3 = false">{{$t('稍后再说')}}</div>
						<div class="choiceFood_16_2 pointer" @click="caozuo(8)">{{$t('立即充值')}}</div>
					</div>
				</div>
			</div>
		</el-dialog>
		
	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				addres_list:[],
				addres_id:'',
				visible1:false,
				visible2:false,
				visible3:false,
				detail:{
					content:''
				},
				xuan_detl:true,
				can_type:{
					aid:1,
				},
				oerde_list:[],
				piao:'',
				tao_item:'',
				post_type:false,
				shu_num:'',
				total:0,
				page:1,
				page_size:10,
				loading:true,
				textarea:'',
			}
		},
		created() {
			if (window.sessionStorage.getItem('can_type')) {
				this.can_type = JSON.parse(window.sessionStorage.getItem('can_type'))
			}
			if(window.sessionStorage.getItem('token')){
				this.post68d271a2aef69()
				this.post68d3bf9d40c03()
				this.post636f7683cf195()
			}else{
				this.$router.push({
					name: 'login',
				});
			}
			
		},

		methods: {
			gengxin(){
				this.loading = true
				this.post68d271a2aef69()
				this.post68d3bf9d40c03()
				this.post636f7683cf195()
				if(!this.xuan_detl){
					this.post68e4b3ce32281()
				}
			},
			// 地址列表
			post636f7683cf195(){
				this.$api.post(this.$apiUrls.post636f7683cf195,{page:1,pagesize:50,list_rows:50}).then((res) => {
					if(res.code == 1){
						this.addres_list = res.data.data
					}else{
						this.$message.error(res.msg);
						return
					}
				})
			},
			// 详情
			post68e4b3ce32281(){
				this.$api.post(this.$apiUrls.post68e4b3ce32281,{aid:this.tao_item.aid}).then((res) => {
					if(res.code == 1){
						this.detail = res.data
					}else{
						this.$message.error(res.msg);
						return
					}
				})
			},
			// 确定选择地址
			queding(){
				// addres_id
				if(!this.addres_id){
					this.$message.error(this.$t('请选择地址'));
					return
				}
				if(this.post_type){
					return
				}
				this.post_type = true
				this.$api.post(this.$apiUrls.post68d8f52b8968f,{address_id:this.addres_id,packeage_info:JSON.stringify(this.shu_num),remark:this.textarea,}).then((res) => {
					if(res.code == 1){
						this.visible1 = false
						this.post_type = false
						
						this.$router.replace({
							name: 'orderPlaced',
						});
					}else{
						this.$message.error(res.msg);
						this.post_type = false
						return
					}
				})
			},
			
			// 提交
			tijiao(){
				
				
				let shu_num = []
				let list_num = []
				let list = this.oerde_list
				for (var i = 0; i < list.length; i++) {
					list[i].shu_num = 1
					if(list[i].xu_bur){
						list_num.push(1)
						for (var j = 0; j < list[i].package_list.length; j++) {
							if(list[i].package_list[j].num > 0){
								list[i].shu_num = 2
								shu_num.push({
									num: list[i].package_list[j].num,
									package_aid: list[i].package_list[j].aid,
									name: list[i].package_list[j].name,
									price: list[i].package_list[j].price,
								})
							}
						}
					}
				}
				if(list_num.length == 0){
					this.$message.error(this.$t('请选择菜品'));
					return
				}
				
				// 是否选择数量
				for (var i = 0; i < list.length; i++) {
					if(list[i].xu_bur && list[i].shu_num == 1){
						// console.log(list[i].shu_num,1111111111)
						this.visible2 = true
						return
					}
				}
				// 是否购票
				let piao_num = 0
				for (var i = 0; i < shu_num.length; i++) {
					piao_num = parseInt(piao_num) + (parseInt(shu_num[i].num) * parseInt(shu_num[i].price))
				}
				 // console.log(piao_num,this.can_type.aid,111111111)
				 // console.log(this.piao.meal_ticket_two,this.piao.meal_ticket_three,22222)
				 // return
				this.shu_num = shu_num
				if (this.can_type.aid == '1') {
					if (this.piao.meal_ticket_two >= piao_num) {
						this.textarea = ''
						this.visible1 = true;
					} else {
						this.visible3 = true;
					}
				} else {
					if (this.piao.meal_ticket_three >= piao_num) {
						this.textarea = ''
						this.visible1 = true;
					} else {
						this.visible3 = true;
					}
				}
			   
			},
			//获取会员饭票资产
			post68d3bf9d40c03(){
				this.$api.post(this.$apiUrls.post68d3bf9d40c03).then((res) => {
					if(res.code == 1){
						this.piao = res.data
					}else{
						this.$message.error(res.msg);
						return
					}
				})
			},
			// 获取套餐列表
			post68d271a2aef69(){
				this.$api.post(this.$apiUrls.post68d271a2aef69,{packagecate_id:this.can_type.aid}).then((res) => {
					if(res.code == 1){
						let list = res.data
						for (var i = 0; i < list.length; i++) {
							list[i].xu_bur = true
							for (var j = 0; j < list[i].package_list.length; j++) {
								list[i].package_list[j].num = 0
							}
						}
						this.oerde_list = list
						this.loading = false
					}else{
						this.$message.error(res.msg);
						return
					}
				})
			},
			caozuo(type,item,index){
				if(type == 1){ //返回上一页
					if(this.xuan_detl){
						// this.$router.push({
						// 	name: 'orderFood',
						// });
						window.history.back();
						return
					}else{
						this.xuan_detl = true
					}
				}else if(type == 2){ // 选择套餐
					this.oerde_list[item].xu_bur = !this.oerde_list[item].xu_bur
				}else if(type == 3){ // 减少数量
					if(this.oerde_list[item].package_list[index].num > 0){
						this.oerde_list[item].package_list[index].num
					}
				}else if(type == 4){ // 增加数量
					this.oerde_list[item].package_list[index].num++
				}else if(type == 5){ // 商品详情
				    this.tao_item = item
					this.xuan_detl = false
					this.post68e4b3ce32281()
				}else if(type == 6){ // 地址选择
					this.addres_id = item.aid
				}else if(type == 7){ // 添加地址
					this.$router.push({
						name: 'addresDetal',
					});
				}else if(type == 8){ // 立即充值
				    this.visible3 = false
					this.$router.push({
						name: 'topUp',
					});
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	::v-deep {
		 .beizhu_1{
			 .el-textarea__inner {
			    height: 100%; /* 在小屏幕上调整高度 */
				 resize: none;
			  }
			  
		 } 
		.footer_6{
			.el-dialog__header{
				display: none;
			}
			.el-dialog__body{
				padding: 0 !important;
				border-radius: 16px 16px 16px 16px;
				// background: rgba(187,195,211,0) !important;
			}
		}
		.el-loading-mask {
			opacity: 1 !important; 
			background-color: rgba(255, 255, 255, 1) !important;
		}
	}
	.choiceFood{
		padding: 0 20px 32px;
		background: #fff;
		margin-top: 20px;
		border-radius: 16px;
	}
	.choiceFood_1{
		padding: 21px 0;
		border-bottom: 1px solid #EEEEEE;
	}
	.login_14_1{
		width: 14px;
		height: 14px;
		
	}
	.login_14_2{
		font-weight: 400;
		font-size: 16px;
		color: #666666;
		margin-left: 12px;
	}
	.choiceFood_2{
		margin: 24px 0 16px 0;
	}
	.choiceFood_2_1{
		font-weight: 500;
		font-size: 16px;
		color: #1A1A1A;
	}
	.choiceFood_2_2{
		width: 96px;
		height: 40px;
		background: #FF770F;
		border-radius: 8px 8px 8px 8px;
		text-align: center;
		line-height: 40px;
		font-weight: 400;
		font-size: 16px;
		color: #FFFFFF;
	}
	.choiceFood_3_1{
		width: 22px;
		height: 22px;
		border: 1px dashed #000;
	}
	.choiceFood_3_2{
		width: 20px;
		height: 20px;
		margin: 0 auto;
	}
	.choiceFood_3_3{
		font-weight: 400;
		font-size: 14px;
		color: #333333;
		margin: 0 0 0 10px;
	}
	.choiceFood_4{
		width: 100%;
		margin: 16px 0 24px 0;
		padding: 16px 16px 16px 16px;
		background: #F8F8FA;
		border-radius: 8px 8px 8px 8px;
	}
	.choiceFood_5{
		margin: 0px 0 16px 0;
	}
	.choiceFood_6{
		width: 120px;
		height: 120px;
		border-radius: 6px;
	}
	.choiceFood_7{
		height: 120px;
		margin: 0 0 0 16px;
	}
	.choiceFood_7_1{
		font-weight: 500;
		font-size: 14px;
		color: #1A1A1A;
	}
	.choiceFood_7_2{
		font-weight: 400;
		font-size: 12px;
		color: #666666;
		margin: 12px 0 0 0;
	}
	.choiceFood_7_3{
		margin: auto 0 0 0;
	}
	.choiceFood_7_4{
		width: 20px;
		height: 20px;
	}
	.choiceFood_7_5{
		font-weight: 400;
		font-size: 14px;
		color: #666666;
		margin: 0 12px;
	}
	.choiceFood_8{
		width: 800px;
		margin: 0 auto;
		padding: 24px 0 32px 0;
	}
	.choiceFood_8_1{
		font-weight: 500;
		font-size: 20px;
		color: #1A1A1A;
	}
	.choiceFood_8_2{
		font-weight: 400;
		font-size: 14px;
		color: #999999;
	}
	.choiceFood_8_3{
		width: 100%;
		border-top: 1px solid #EEEEEE;
		margin: 30px 0 20px 0;
	}
	.index8 {
		height: 550px;
		overflow-y: auto;
	}
	.choiceFood_9{
		width: 560px;
		// height: 573px;
		padding: 0 0 40px 0;
		background: #FFFFFF;
		border-radius: 8px 8px 8px 8px;
	}
	.choiceFood_9_1{
		width: 100%;
		height: 56px;
		background: #F3F3F3;
		border-radius: 8px 8px 0px 0px;
		padding: 0 20px;
	}
	.choiceFood_9_2{
		font-weight: bold;
		font-size: 16px;
		color: #333333;
	}
	.choiceFood_9_3{
		width: 24px;
		height: 24px;
	}
	.choiceFood_10{
		// width: 520px;
		height: 400px;
		padding: 25px 32px 0;
		box-sizing: border-box;
		// background: red;
		overflow-y: auto;
	}
	.choiceFood_10_1{
		width: 496px;
		// height: 80px;
		padding: 16px 24px;
		background: #FFFFFF;
		border-radius: 4px 4px 4px 4px;
		border: 1px solid #CCCCCC;
		margin: 0 0 24px 0;
	}
	.choiceFood_10_1s{
		width: 496px;
		// height: 80px;
		padding: 16px 24px;
		background: #FFFFFF;
		border-radius: 4px 4px 4px 4px;
		border: 1px solid #FF8A24;
		margin: 0 0 24px 0;
	}
	.choiceFood_10_2{
		width: 32px;
		height: 32px;
		margin-right: 16px;
	}
	.choiceFood_10_3{
		font-weight: 400;
		font-size: 16px;
		color: #333333;
	}
	.choiceFood_10_4{
		font-weight: 400;
		font-size: 14px;
		color: #666666;
		margin: 6px 0 0 0;
	}
	
	.choiceFood_11{
		padding: 32px 32px 0px 32px;
	}
	.choiceFood_11_1{
		min-width: 100px;
		height: 36px;
		border-radius: 4px 4px 4px 4px;
		border: 1px solid #FF8A24;
		font-weight: 400;
		font-size: 14px;
		color: #FF8A24;
		text-align: center;
		line-height: 36px;
		margin: 0 0 0 auto;
	}
	.choiceFood_11_2{
		width: 100px;
		height: 36px;
		background: #FF770F;
		border-radius: 4px 4px 4px 4px;
		text-align: center;
		line-height: 36px;
		font-weight: 400;
		font-size: 14px;
		color: #FFFFFF;
		margin: 0 0 0 20px;
	}
	.choiceFood_12{
		width: 148px;
		height: 102px;
		margin: 40px 0 0 0;
	}
	.choiceFood_12_1{
		font-weight: 400;
		font-size: 14px;
		color: #333333;
		margin: 16px 0 40px;
	}
	.choiceFood_12_2{
		width: 100px;
		height: 36px;
		border-radius: 4px 4px 4px 4px;
		border: 1px solid #FF8A24;
		font-weight: 400;
		font-size: 14px;
		color: #FF8A24;
		text-align: center;
		line-height: 36px;
		margin: 0 0 0 0;
	}
	.choiceFood_13{
		width: 132px;
		height: 36px;
		background: #FF770F;
		border-radius: 4px 4px 4px 4px;
		text-align: center;
		line-height: 36px;
		font-weight: 400;
		font-size: 14px;
		color: #FFFFFF;
	}
	.choiceFood_14{
		font-weight: 400;
		font-size: 16px;
		color: #333333;
		margin: 40px 0;
	}
	.choiceFood_15{
		font-weight: bold;
		font-size: 16px;
		color: #333333;
		margin: 20px 0 24px 0;
	}
	.choiceFood_16_1{
		width: 100px;
		height: 36px;
		border-radius: 4px 4px 4px 4px;
		border: 1px solid #CCCCCC;
		text-align: center;
		line-height: 36px;
		font-weight: 400;
		font-size: 14px;
		color: #333333;
		margin: 0 20px 0 auto;
	}
	.choiceFood_16_2{
		width: 100px;
		height: 36px;
		background: #FF770F;
		border-radius: 4px 4px 4px 4px;
		text-align: center;
		line-height: 36px;
		font-weight: 400;
		font-size: 14px;
		color: #FFFFFF;
	}
	.choiceFood_17{
		padding: 0 20px;
	}
	.orderFood_6{
		margin: 0px 0 32px 0;
	}
	.orderFood_7{
		width: 100%;
		height: 700px;
	}
	.beizhu{
		padding:32px 32px 0;
	}
	.beizhu_1{
		margin: 24px 0 0 0;
		height: 100px;
	}
</style>